/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AddCourseModuleRequest } from './addCourseModuleRequest';

export type AddModuleToCourseBody = AddCourseModuleRequest | null;
